export default __webpack_public_path__ + "static/media/international_header_logo.f3c0f77a.png";